import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=22ba47ca&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ba47ca')) {
      api.createRecord('22ba47ca', component.options)
    } else {
      api.reload('22ba47ca', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=22ba47ca&", function () {
      api.rerender('22ba47ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard.vue"
export default component.exports